import { render, staticRenderFns } from "./ViewDocs.vue?vue&type=template&id=d29af66a&scoped=true&"
import script from "./ViewDocs.vue?vue&type=script&lang=js&"
export * from "./ViewDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29af66a",
  null
  
)

export default component.exports